import { call, put, takeLatest, all } from 'redux-saga/effects'
import { fetchFaqs } from './actions'
import { apiFetchFaqByPhone } from '../Faq/services'
import { FETCH_DEVICES } from '../DeviceSlider/constants'

function* fetchFaqWorker(action) {
  const freeNavDevices = action.devices.filter((device) =>
    /freenav/.test(device.customerID)
  )

  try {
    const faqs = yield all(
      freeNavDevices.map((device) => call(apiFetchFaqByPhone, device.id))
    )

    const devicesWithPk = freeNavDevices.map((device) => {
      const faq = faqs.find((faq) => faq.phonefk === device.id)
      return { ...device, faqPk: faq && faq.PK }
    })

    yield put(fetchFaqs.success(devicesWithPk))
  } catch (e) {
    // No action when free nav FAQs are not available
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_DEVICES.SUCCESS, fetchFaqWorker)
}
